import React from 'react';
import axios from 'axios';
import { Button, Modal, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

var UpdateListwa = React.createClass({

	getInitialState: function() {
		return {
			updateObject: {
				id: '',
				numerListwy: '',
				iloscCm: '',
				ilot: '',
			}
		}
    },

		render: function() {

			return (
				<Modal show={this.props.parent.state.showUpdateModal}>
					<Modal.Header>
						<Modal.Title>Aktualizuj Listwę</Modal.Title>
					</Modal.Header>
					<Modal.Body>
					<div className="row">
						<div className="col-sm-4">
							<ControlLabel>Numer Listwy: </ControlLabel>
						</div>
						<div className="col-sm-8">
						<FormControl
							type="text"
							placeholder="Numer Listwy"
							value={this.state.updateObject.numerListwy}
							onChange={this.onUpdateListwaNumerChange} />
						</div>
					</div>

					<div className="row">
						<div className="col-sm-4">
							<ControlLabel>Ilość cm: </ControlLabel>
						</div>
						<div className="col-sm-8">
						<FormControl
							type="text"
							placeholder="Ilość cm"
							value={this.state.updateObject.iloscCm}
							onChange={this.onUpdateListwaIloscChange} />
						</div>
					</div>

					<div className="row">
						<div className="col-sm-4">
							<ControlLabel>Ilot: </ControlLabel>
						</div>
						<div className="col-sm-8">
						<FormControl
							type="text"
							placeholder="Ilot"
							value={this.state.updateObject.ilot}
							onChange={this.onUpdateListwaIlotChange} />
						</div>
					</div>


					</Modal.Body>
					<Modal.Footer>
						<Button onClick={this.props.parent.closeUpdateModal}>Zamknij</Button>
						<Button bsStyle="primary" onClick={this.onUpdateBtnClicked}>Aktualizuj</Button>
					</Modal.Footer>
				</Modal>
			);
		},

	fillUpdateObject: function() {
    	var selectedListwa = this.props.parent.getListwaById(this.props.parent.state.selectedListwaId);

			this.state.updateObject = {
			id: selectedListwa.id,
			numerListwy: selectedListwa.numerListwy,
			iloscCm: selectedListwa.iloscCm,
			ilot: selectedListwa.ilot
		}
	},

	clearUpdateObject: function() {
		this.state.updateObject.id = '';
		this.state.updateObject.numerListwy = '';
		this.state.updateObject.iloscCm = '';
		this.state.updateObject.ilot = '';
	},

	onUpdateListwaNumerChange: function(event) {
		this.state.updateObject.numerListwy = event.target.value;
		this.forceUpdate();
	},

	onUpdateListwaIloscChange: function(event) {
		this.state.updateObject.iloscCm = event.target.value.replace(/,/g, '.');
		this.forceUpdate();
	},

	onUpdateListwaIlotChange: function(event) {
		this.state.updateObject.ilot = event.target.value;
		this.forceUpdate();
	},

	onUpdateBtnClicked: function() {
		axios.put('http://217.182.200.222:8080/stanListwy/' + this.state.updateObject.id, this.state.updateObject)
			.then(function (response) {
				this.props.parent.closeUpdateModal();
				this.props.parent.refreshTable();
			}.bind(this))
			.catch(function (error) {
				alert("Błędnie wprowadzone dane");
				console.log(error);
			});
	}
});

export default UpdateListwa;



// WEBPACK FOOTER //
// ./src/components/StanListwy/UpdateListwa.js